import FormInput from 'components/ui/composed/declarations/formInput/DeclarationInput';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FormCard from 'views/declarations/common/cards/FormCard';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import { getFormikProps } from 'views/declarations/utils/form-utils';

const AdditionalInformationCard: FC<DeclarationFormCardProps> = ({
    selectCard,
    keyCard,
    defaultOpen = false,
    viewOnly = false,
    expandAll = false,
    cardTotal,
    cardNumber,
    getFieldHelpers,
    getFieldProps,
    getFieldMeta,
}) => {
    const { t } = useTranslation('form');
    return (
        <section
            id={'deposit-additional-information-form-card'}
            onClick={() => {
                if (selectCard) {
                    selectCard('deposit-additional-information-form-card');
                }
            }}
        >
            <FormCard
                key={keyCard}
                keyCard={keyCard}
                defaultOpen={defaultOpen}
                viewOnly={viewOnly}
                title={t('additionalInformation.title')}
                expandAll={expandAll}
                cardNumber={cardNumber}
                total={cardTotal}
                showRightSideCardState={false}
            >
                <FormInput
                    viewOnly={viewOnly}
                    {...getFormikProps(`periodOfDischarge`, { getFieldHelpers, getFieldProps, getFieldMeta })}
                    label={t('depositRefund.periodOfDischarge')}
                />
                <FormInput
                    viewOnly={viewOnly}
                    {...getFormikProps(`rateOfYield`, { getFieldHelpers, getFieldProps, getFieldMeta })}
                    label={t('depositRefund.rateOfYield')}
                />
            </FormCard>
        </section>
    );
};
export default AdditionalInformationCard;
